import { createContext, type ReactNode, useContext } from 'react';
import { type InventoryDetailsDataFragment } from '../../../api/fragments/InventoryDetailsData';

export const InventoryContext = createContext<InventoryDetailsDataFragment>(null);

export const InventoryProvider = ({
    inventory,
    children,
}: {
    inventory: InventoryDetailsDataFragment;
    children: ReactNode;
}) => <InventoryContext.Provider value={inventory}>{children}</InventoryContext.Provider>;

export const useInventory = () => {
    const inventory = useContext(InventoryContext);

    if (!inventory) {
        throw new Error('Inventory context not available');
    }

    return inventory;
};
